// extracted by mini-css-extract-plugin
export default {"button":"shared_button__TqVCb","popover__option":"shared_popover__option__DVdTs"};